import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { bonuses } from "../../data/content";
export function BonusesSection() {
  return <section className="bg-navy-950 px-3 py-16 sm:px-5 sm:py-20" data-id="element-114" data-mp="qek3y3led76d">
      <div className="mx-auto max-w-6xl" data-id="element-115" data-mp="vcvd0c3vbdnj">
        <div className="px-2" data-id="element-116" data-mp="vdwqen8cwc8f">
          <SectionHeading tone="dark" kicker="5 exclusive bonuses" title={<>
                Plus, You'll Receive These 5 Practical Clinical Resources <span className="text-gold" data-id="element-118" data-mp="19bldm1pwbvgn">at No Additional Cost</span>
              </>} lead="These bonuses complement the six-volume library with focused tools for everyday professional reference." data-id="element-117" data-mp="1j1oesp768fq2" />
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-119" data-mp="21zh76xk65797">
          {bonuses.map(b => <article key={b.number} className="flex flex-col overflow-hidden rounded-3xl bg-white" data-id="element-120" data-mp="26sjz719as8na">
              <div className="relative" data-id="element-121" data-mp="2m60lqc74ybwq">
                <img src={b.image} alt={`${b.title} — ${b.number} mockup`} className="aspect-[4/3] w-full object-cover" data-id="element-122" data-mp="2h6nwjkssksqz" />
                <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-violet-700 px-3 py-1.5 font-display text-[13px] font-black uppercase text-white" data-id="element-123" data-mp="2vvk1h8zjxpnd">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="34vqd0pbowfjw" />
                  {b.number}
                </span>
              </div>
              <div className="flex flex-1 flex-col px-5 pb-5 pt-4" data-id="element-125" data-mp="2zw3zsfvv2zb3">
                <h3 className="font-display text-[21px] font-black leading-tight text-navy-950" data-id="element-126" data-mp="3eupmub86yh8h">{b.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-127" data-mp="39utj8d3eortg">{b.description}</p>
                <ul className="mt-4 space-y-2" data-id="element-128" data-mp="1kfdauzxb3a4m">
                  {b.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-129" data-mp="1fhlhe1h0jfyb">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-130" data-mp="255pjf26bhsh2" />
                      {item}
                    </li>)}
                </ul>
                {b.note && <p className="mt-3 text-[13px] italic text-muted" data-id="element-131" data-mp="2e4uh66a21hs6">{b.note}</p>}
                <div className="mt-auto pt-5" data-id="element-132" data-mp="2j5i9cva0s4nz">
                  <div className="flex items-center justify-between rounded-2xl bg-mist px-4 py-3" data-id="element-133" data-mp="2j6a463vslyd7">
                    <span className="text-[14px] font-semibold text-muted" data-id="element-134" data-mp="2o3tit4wekd5o">
                      Value: <span className="line-through" data-id="element-135" data-mp="2s43yxadwsjy9">${b.value} USD</span>
                    </span>
                    <span className="font-display text-[18px] font-black uppercase text-cta" data-id="element-136" data-mp="2wwx41zdahuav">Today: Free</span>
                  </div>
                </div>
              </div>
            </article>)}
        </div>
        <div className="px-2" data-id="element-137" data-mp="36sglxhv0qsgm">
          <SectionCta tone="dark" label="Claim my 5 free bonuses" note="Bonuses included only with today's launch offer" data-id="element-138" data-mp="3bted2jy0awu9" />
        </div>
      </div>
    </section>;
}